export default __webpack_public_path__ + "static/Entenda0067-f517a7666ba7cd1cf1f0371e85b96578.jpg";